export class SeededRNG {
  private seed: number;

  constructor(seed: number = Date.now()) {
    this.seed = seed;
  }

  next(): number {
    this.seed = (this.seed * 1103515245 + 12345) & 0x7fffffff;
    return this.seed / 0x7fffffff;
  }

  nextInt(min: number, max: number): number {
    return Math.floor(this.next() * (max - min + 1)) + min;
  }

  nextFloat(min: number, max: number): number {
    return this.next() * (max - min) + min;
  }

  shuffle<T>(array: T[]): T[] {
    const result = [...array];
    for (let i = result.length - 1; i > 0; i--) {
      const j = this.nextInt(0, i);
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  }

  pick<T>(array: T[]): T | undefined {
    if (array.length === 0) return undefined;
    return array[this.nextInt(0, array.length - 1)];
  }

  pickWeighted<T>(items: { item: T; weight: number }[]): T | undefined {
    if (items.length === 0) return undefined;
    const totalWeight = items.reduce((sum, i) => sum + i.weight, 0);
    let threshold = this.nextFloat(0, totalWeight);
    for (const { item, weight } of items) {
      threshold -= weight;
      if (threshold <= 0) return item;
    }
    return items[items.length - 1].item;
  }

  getSeed(): number {
    return this.seed;
  }

  reset(seed: number): void {
    this.seed = seed;
  }
}
